import React from 'react';
import PingStatus from '../monitoramento/PingStatus';

export default function Zcompnfe() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:826/ping"
      pingAuth={{ username: 'Portal', password: 'Portal1163' }}
      restartKey="apicompnfe"
      interval={20000}
    />
  );
}
